import React from 'react';

import { Checkbox } from '@mui/material';

import { DARK_GREY, DIVIDER, GREY, SCOUT_TEAL } from '../../ThemeContext/constants';

import type { ChangeEvent } from 'react';

export interface FormCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

const checkboxSx = {
  color: DIVIDER,
  padding: 'unset',
  marginRight: 1,
  '& .MuiSvgIcon-root': {
    fontSize: '20px'
  },
  '&.Mui-checked': {
    color: SCOUT_TEAL
  }
};

const FormCheckbox = ({
  id,
  checked,
  onChange,
  label,
  disabled = false
}: FormCheckboxProps): React.ReactElement => (
  <label
    htmlFor={id}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      cursor: disabled ? 'default' : 'pointer',
      margin: 'unset',
      marginBottom: '10px'
    }}
  >
    <Checkbox checked={checked} disabled={disabled} id={id} onChange={onChange} sx={checkboxSx} />
    <span
      style={{
        fontFamily: 'Source Sans Pro, sans-serif',
        fontSize: '14px',
        color: disabled ? DARK_GREY : GREY
      }}
    >
      {label}
    </span>
  </label>
);

export default FormCheckbox;
